import { type Node, Element, type NodeEntry, Path } from 'slate';
import { type ListElement, type ListItemElement } from '../../types/aha-editor';

export const isListItemEntry = (
  entry: NodeEntry
): entry is NodeEntry<ListItemElement> =>
  isListItem(entry[0]) && Path.isPath(entry[1]);

export const isListItem = (element: Node): element is ListItemElement =>
  Element.isElement(element) && element.type === 'list_item';

export const SUPPORTED_TYPES = ['ol_list', 'ul_list', 'checklist', 'dl_list'];

// Match function for checkbox list items.
export const isCheckboxListItem = (
  element: Node
): element is ListItemElement => {
  // A block element is a checkbox list item when it matches ListItem and
  // it has a list_checked property with a checked value within.
  return isListItem(element) && Object.hasOwn(element, 'list_checked');
};

export const isList = (element: Node): element is ListElement => {
  return Element.isElement(element) && SUPPORTED_TYPES.includes(element.type);
};
